module.exports = {
  label: {
    heading: 'User Login',
    userName: 'Username',
    passport: 'ID/Passport',
    password: 'Password',
    loginAs: 'Login as',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    signUp: "Sign up here",
    invalidCredentials:"Your creadentials are invalid",
    buttons: {
      logIn: 'Log In'
    }
  }
}
